import React from 'react';

export const ArrowLongRightSvg = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <path
            fill="currentColor"
            d="M12.293 19.707a1 1 0 0 1 0-1.414l3.535-3.536c.638-.637 1.575-1.273 2.4-1.774q.081-.049.15-.109l-.144-.143C17.478 12.884 16.68 13 16 13H4a1 1 0 1 1 0-2h12c.681 0 1.478.116 2.233.269l.144-.143a1 1 0 0 0-.149-.11c-.825-.5-1.762-1.136-2.4-1.773l-3.535-3.536a1 1 0 1 1 1.414-1.414l7 7a1 1 0 0 1 0 1.414l-7 7a1 1 0 0 1-1.414 0"
        />
    </svg>
);
